import React from 'react';

export interface ShieldIconProps {
  /** When false the icon is not rendered (default true) */
  show?: boolean;
  /** Fill color — default golden amber */
  color?: string;
  /** Stroke color — default black */
  strokeColor?: string;
  /** Stroke width in px — default 2 */
  strokeWidth?: number;
  /** Icon size in px — default 12 */
  size?: number;
  /** Extra margin-left in px — default 6 */
  marginLeft?: number;
  title?: string;
}

export default function ShieldIcon({
  show = true,
  color = '#f59e0b',
  strokeColor = '#000',
  strokeWidth = 2,
  size = 18,
  marginLeft = 6,
  title = 'Requiere autorización',
}: ShieldIconProps) {
  if (!show) return null;

  return (
    <span
      title={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft,
        verticalAlign: 'middle',
        flexShrink: 0,
      }}
    >
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
          fill={color}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
        />
        {/* Double checkmark (inset with margin from shield border) */}
        <path
          d="M5.5 12 L8 14.5 L12 10"
          fill="none"
          stroke="#000"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 12 L12 14.5 L16 10"
          fill="none"
          stroke="#000"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
